// extracted by mini-css-extract-plugin
export default {"dialog":"dialog_dialog__c-hz7","content":"dialog_content__8Po0F","description":"dialog_description__+6ZXi","isTitle":"dialog_isTitle__PnPAO","buttonBox":"dialog_buttonBox__SCa8x"};